import { render } from "./HomeMethodElement.vue?vue&type=template&id=4b371f66&scoped=true"
import script from "./HomeMethodElement.vue?vue&type=script&lang=js"
export * from "./HomeMethodElement.vue?vue&type=script&lang=js"

import "./HomeMethodElement.vue?vue&type=style&index=0&id=4b371f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b371f66"]])

export default __exports__